var SVGator_Reveals = {
	init:function(){

		$(window).scroll(function(){
			SVGator_Reveals.scroll();
		})

		SVGator_Reveals.scroll();

	},
	scroll:function(){
		var _min = window.scrollY + (0.8 * window.innerHeight);
		var _max = window.scrollY - (0.2 * window.innerHeight);

		var els = document.getElementsByClassName("svgator-reveal");
		
		Array.prototype.forEach.call(els, function(el) {
			var topPos = el.getBoundingClientRect().top + window.scrollY
			
			if((topPos < _min) && (topPos > _max)){
				if(!el.classList.contains('played')) {
					el.classList.add("played");
					var _svgs = el.getElementsByTagName("svg");
					var _isObject = el.getElementsByTagName("object")[0];

					if(typeof _isObject == "undefined"){
						Array.prototype.forEach.call(_svgs, function(_svg) {
							_svg.dispatchEvent(new Event("click"));
						});
					}else{
						var _svgs_2 = el.getElementsByTagName("object")[0].getSVGDocument().getElementsByTagName("svg")[0];
						_svgs_2.dispatchEvent(new Event("click"));
					}


					if(el.classList.contains("svgator-reveal-once")){
						el.classList.remove("svgator-reveal-once");
						el.classList.remove("svgator-reveal");
					}

				}
			}else{
				if(el.classList.contains('played')) {
					el.classList.remove("played");
					var _svgs = el.getElementsByTagName("svg");					
					var _isObject = el.getElementsByTagName("object")[0];

					if(typeof _isObject == "undefined"){
						Array.prototype.forEach.call(_svgs, function(_svg) {
							_svg.dispatchEvent(new Event("click"));
						});
					}else{
						var _svgs_2 = el.getElementsByTagName("object")[0].getSVGDocument().getElementsByTagName("svg")[0];
						_svgs_2.dispatchEvent(new Event("click"));
					}
				}
			}
		});
	}
}
var SVGator_Reveals_Load = {
	init:function(){

		var els = document.getElementsByClassName("svgator-reveal-load");


		Array.prototype.forEach.call(els, function(el) {
			el.classList.add("played");
			var _svgs = el.getElementsByTagName("svg");
			var _isObject = el.getElementsByTagName("object")[0];

			if(typeof _isObject == "undefined"){
				Array.prototype.forEach.call(_svgs, function(_svg) {
					_svg.dispatchEvent(new Event("click"));
				});

			}else{
				var _svgs_2 = el.getElementsByTagName("object")[0].getSVGDocument().getElementsByTagName("svg")[0];
				_svgs_2.dispatchEvent(new Event("click"));
			}
		});


	}
}
$(window).load(function(){
	if($(".svgator-reveal").length){
		SVGator_Reveals.init();
	}
	if($(".svgator-reveal-load").length){
		setTimeout(function(){
			SVGator_Reveals_Load.init();
		}, 500);
	}
});